import script from "./style.vue?vue&type=script&lang=ts&setup=true"
export * from "./style.vue?vue&type=script&lang=ts&setup=true"

import "./style.vue?vue&type=style&index=0&id=d1d52250&lang=less"

const __exports__ = script;

export default __exports__